module.exports = __webpack_public_path__ + "img/muster.fda20698.png";